// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091439/js/" + chunkId + "." + {"44":"d3a6fdd7","225":"76306619","481":"5d7e890b","486":"4c6f64d3","770":"6909a52b"}[chunkId] + ".0.41949771557712445.chunk.js";
};